import { IPolicyRuleComparator } from '@entities/policy';
import { ISelectMultiOption } from '@shared/components/Form';

export type MultiParam = {
  techname: string;
  label: string;
  type: 'multi-select';
  values: Record<string, string>;
  selected: ISelectMultiOption[];
};

export type DigitOperator = '=' | '<' | '>' | '<=' | '>=';

/**
 * Single source of truth for comparison operators: each display symbol paired with its
 * payload comparator key. The UI operator list and the serialize/deserialize maps all derive
 * from this — change the operator set here only.
 */
export const OPERATOR_COMPARATORS: ReadonlyArray<{
  operator: DigitOperator;
  key: keyof IPolicyRuleComparator;
}> = [
  { operator: '=', key: 'eq' },
  { operator: '>', key: 'gt' },
  { operator: '>=', key: 'gte' },
  { operator: '<', key: 'lt' },
  { operator: '<=', key: 'lte' },
];

export const DIGIT_OPERATORS: DigitOperator[] = OPERATOR_COMPARATORS.map(item => item.operator);

export type DigitParam = {
  techname: string;
  label: string;
  type: 'digit-compare';
  operator: DigitOperator;
  value: string;
};

export type TagDigitParam = {
  techname: string;
  label: string;
  type: 'tag-digit-compare';
  values: Record<string, string>;
  selected: ISelectMultiOption[];
  operator: DigitOperator;
  value: string;
};

export type RuleParam = MultiParam | DigitParam | TagDigitParam;
